import { render, staticRenderFns } from "./lockableLabel.vue?vue&type=template&id=2b502738&scoped=true"
import script from "./lockableLabel.vue?vue&type=script&lang=js"
export * from "./lockableLabel.vue?vue&type=script&lang=js"
import style0 from "./lockableLabel.vue?vue&type=style&index=0&id=2b502738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b502738",
  null
  
)

export default component.exports